<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="transparent" flat elevation="0">
                            <v-toolbar-title class="ml-0"
                                >{{ $t($route.meta.title) }}<bc-breadcrumbs :items="breadcrumb_items"></bc-breadcrumbs
                            ></v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('api_keys.create')" @invoke-method="invokeMethod($event)" action="openApiKeyForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetApiKeys(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="api_keys" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openApiKeyForm(props.item)">
                                <td>
                                    {{ props.item.combined_name }}<small>{{ props.item.company_id }}</small>
                                </td>
                                <td>{{ props.item.app_name }}</td>
                                <td class="text-center">
                                    <span v-if="$isSet(props.item.max_requests_per_minute)">{{ props.item.max_requests_per_minute }} / Min</span>
                                    <br v-if="$isSet(props.item.max_requests_per_hour) && $isSet(props.item.max_requests_per_minute)" />
                                    <span v-if="$isSet(props.item.max_requests_per_hour)">{{ props.item.max_requests_per_hour }} / Hour</span>
                                </td>
                                <td class="text-center">
                                    <v-chip class="br-7" small dark :color="props.item.ignore_limits == 1 ? 'success' : 'error'">{{
                                        props.item.ignore_limits == 1 ? "Yes" : "No"
                                    }}</v-chip>
                                </td>
                                <td>
                                    <span v-if="$isSet(props.item.ip_addresses)" class="align-center d-flex">
                                        {{ props.item.ip_addresses.split(",")[0] }}
                                        <bc-tooltip v-if="props.item.ip_addresses.split(',').length > 1" class="br-7">
                                            <template slot="activator">
                                                <v-chip class="br-7" small>
                                                    {{ `+${props.item.ip_addresses.split(",").length - 1}` }}
                                                </v-chip>
                                            </template>
                                            <v-list style="background: transparent">
                                                <v-list-tile v-for="(ip, index) in props.item.ip_addresses.split(',').slice(1)" :key="index">
                                                    <v-list-tile-title style="color: white">{{ ip }}</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </bc-tooltip>
                                    </span>
                                    <span v-else>
                                        {{ $t("lang.no_ip_restrictions") }}
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="api_keys"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="api_key_dialog" max-width="800">
                <v-card>
                    <v-form ref="form_api_key">
                        <v-card-title>
                            <span class="headline">{{ api_key.api_keys_id ? $t("lang.edit_api_key") : $t("lang.add_api_key") }}</span>
                            <v-spacer></v-spacer>
                            <v-btn v-if="$isSet(api_key.api_keys_id)" icon @click="openApiKeysHistory(api_key)">
                                <v-icon>hgi hgi-stroke hgi-clock-04</v-icon>
                            </v-btn>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeApiKeyDialog"
                                :dialog-status="api_key_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex :xs6="$isSet(api_key.company_id)" v-if="$isSet(api_key.user_id)">
                                        <v-text-field
                                            :value="api_key.combined_name"
                                            :label="$t('lang.user')"
                                            readonly
                                            class="br-7"
                                            style="caret-color: transparent !important"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6 v-if="$isSet(api_key.company_id)">
                                        <v-text-field
                                            :value="api_key.company"
                                            :label="$t('lang.company')"
                                            readonly
                                            class="br-7"
                                            style="caret-color: transparent !important"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-if="$isSet(api_key.api_keys_id)">
                                        <v-text-field
                                            :value="displayedKey"
                                            :label="`${$t('lang.api_key')}`"
                                            readonly
                                            class="br-7"
                                            style="caret-color: transparent !important"
                                        >
                                            <template slot="append">
                                                <bc-tooltip top>
                                                    <template slot="activator">
                                                        <v-btn icon @click="reveal = !reveal">
                                                            <v-icon>{{
                                                                reveal ? "hgi-stroke hgi-rounded hgi-view" : "hgi-stroke hgi-rounded hgi-view-off"
                                                            }}</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ reveal ? $t("lang.hide_content") : $t("lang.show_content") }}</span>
                                                </bc-tooltip>
                                                <bc-tooltip top>
                                                    <template slot="activator">
                                                        <v-btn icon @click="confirmReKey = true">
                                                            <v-icon>hgi-stroke hgi-rounded hgi-repeat</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    {{ $t("lang.regenerate_key") }}
                                                </bc-tooltip>
                                                <bc-tooltip top>
                                                    <template slot="activator">
                                                        <v-btn icon @click="$copyToClipboard(api_key.api_key)">
                                                            <v-icon>hgi hgi-stroke hgi-copy-01</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    {{ $t("lang.copy") }}
                                                </bc-tooltip>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="api_key.app_name"
                                            :label="$t('lang.app_name')"
                                            :counter="showCounter(api_key.app_name, 'api_keys.app_name')"
                                            :rules="ifValid('api_keys.app_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-if="$isSet(api_key.api_keys_id)">
                                        <v-text-field
                                            v-model="api_key.max_requests_per_minute"
                                            :label="`${$t('lang.max_requests_per_minute')} *`"
                                            :rules="ifValid('api_keys.max_requests_per_minute')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-if="$isSet(api_key.api_keys_id)">
                                        <v-text-field
                                            v-model="api_key.max_requests_per_hour"
                                            :label="`${$t('lang.max_requests_per_hour')} *`"
                                            :rules="ifValid('api_keys.max_requests_per_hour')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-select
                                            v-model="api_key.ignore_limits"
                                            :label="`${$t('lang.ignore_limits')} *`"
                                            :items="[
                                                { text: 'Yes', value: '1' },
                                                { text: 'No', value: '0' },
                                            ]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('api_keys.ignore_limits')"
                                        ></bc-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-combobox
                                            v-model="ip_restriction_list"
                                            :items="[]"
                                            :label="`${$t('lang.ip_restrictions')}`"
                                            multiple
                                            chips
                                            deletable-chips
                                            hint="Press enter after each ip address"
                                            persistent-hint
                                            hide-no-data
                                            append-icon=" "
                                        />
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="api_key.api_keys_id" color="error" @mouseup.left="$refs.delete_api_keys.openDialog()">{{ $t("lang.delete") }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeApiKeyDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveApiKeys">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>

            <bc-dialog :value="api_key_history_dialog" fullscreen>
                <v-card style="background: white !important">
                    <v-card-title style="background: #f0f3f7 !important">
                        <span class="headline">{{ $t("lang.api_key_history") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeApiKeyHistoryDialog"
                            :dialog-status="api_key_history_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text style="margin-top: 0px !important">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <vue-perfect-scrollbar style="height: calc(100vh - 150px)">
                                        <v-data-table
                                            :headers="history_headers"
                                            :items="api_key_history || []"
                                            :no-data-text="$t('lang.no_results_matching')"
                                            hide-actions
                                        >
                                            <template slot="items" slot-scope="props">
                                                <tr class="clickable" @mouseup.left="openApiKeysHistoryParams(props.item.id)">
                                                    <td class="text-center">
                                                        <v-chip
                                                            class="br-7 fw-bold"
                                                            small
                                                            dark
                                                            style="background-o"
                                                            :color="
                                                                props.item.response_code >= 0 && props.item.response_code <= 199
                                                                    ? 'primary'
                                                                    : props.item.response_code >= 200 && props.item.response_code <= 299
                                                                    ? 'success'
                                                                    : props.item.response_code >= 300 && props.item.response_code <= 399
                                                                    ? 'warning'
                                                                    : props.item.response_code >= 400 && props.item.response_code <= 599
                                                                    ? 'error'
                                                                    : 'error'
                                                            "
                                                            >{{ props.item.response_code }}</v-chip
                                                        >
                                                    </td>
                                                    <td>{{ props.item.uri }}</td>
                                                    <td class="text-center fw-bold" style="text-transform: uppercase">
                                                        <v-chip
                                                            class="br-7"
                                                            small
                                                            dark
                                                            :color="
                                                                props.item.method == 'get'
                                                                    ? 'primary'
                                                                    : props.item.method == 'post'
                                                                    ? 'success'
                                                                    : props.item.method == 'put' || props.item.method == 'patch'
                                                                    ? 'warning'
                                                                    : props.item.method == 'delete'
                                                                    ? 'error'
                                                                    : 'primary'
                                                            "
                                                            >{{ props.item.method }}</v-chip
                                                        >
                                                    </td>
                                                    <td class="text-center">
                                                        {{ props.item.ip_address }}
                                                    </td>
                                                    <td>
                                                        {{ props.item.date_created }}
                                                    </td>
                                                    <td>{{ props.item.rtime || 0 }} ms</td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </vue-perfect-scrollbar>
                                    <bc-pagination
                                        class="mt-2"
                                        :page="api_key_history_page"
                                        :params="apiKeyHistoryParams"
                                        sendFetch="fetchApiKeyHistory"
                                    ></bc-pagination>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="api_key_history_params_dialog" max-width="1000">
                <v-card>
                    <v-form ref="form_api_key">
                        <v-card-title>
                            <span class="headline">{{ $t("lang.api_key_history_params") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeApiKeyHistoryParamsDialog"
                                :dialog-status="api_key_history_params_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-list>
                                            <v-list-tile v-for="(key, value) of Object.entries(api_key_history_params)">
                                                <v-list-tile-title
                                                    ><strong>{{ key[0] }}:</strong> {{ key[1] }}</v-list-tile-title
                                                >
                                            </v-list-tile>
                                        </v-list>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn flat @mouseup.left="closeApiKeyHistoryDialog()">{{ $t("lang.cancel") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_api_keys"
                :heading="$t('lang.delete_api_key')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteApiKeys(api_key.api_keys_id)"
            ></delete-confirmation-dialog>
            <bc-dialog :value="confirmReKey" max-width="400">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.regenerate_key") }}</span>
                        <v-spacer></v-spacer>
                        <!-- <bc-btn-refresh @invoke-method="getportHistory()"></bc-btn-refresh> -->
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="confirmReKey"
                            :dialog-status="confirmReKey"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <!-- signal chart goes here -->
                    <v-card-text pa-0>
                        <v-container pa-0>
                            <v-layout row wrap>
                                <v-flex xs12> Are you sure you want to generate a new key? </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="confirmReKey = false">{{ $t("lang.no") }}</v-btn>
                        <v-btn color="success" @mouseup.left="reKeyCurrentApiKey(api_key.api_keys_id)">{{ $t("lang.yes") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import phpUnserialize from "phpunserialize";

export default {
    data() {
        return {
            breadcrumb_items: [
                {
                    text: "Dashboard",
                    link: true,
                    exact: true,
                    disabled: false,
                    to: {
                        name: "dashboard",
                    },
                },
                {
                    text: "Configuration",
                    link: true,
                    exact: true,
                    disabled: false,
                    to: {
                        name: "configuration",
                        params: { tab: 5 },
                    },
                },
                {
                    text: "API Keys",
                    disabled: true,
                    href: "",
                },
            ],
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openApiKeyForm" },
                { title: this.$t("lang.refresh"), action: "dbGetApiKeys", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.user"), sortable: false, width: "5%" },
                { text: this.$t("lang.application"), sortable: false, width: "5%" },
                { text: this.$t("lang.max_requests"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.ignore_limits"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.ip_restrictions"), sortable: false, width: "5%" },
            ],
            history_headers: [
                { text: this.$t("lang.code"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.uri"), sortable: false, width: "5%" },
                { text: this.$t("lang.method"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.ip"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.date"), sortable: false, width: "5%" },
                { text: this.$t("lang.run_time"), sortable: false, width: "5%" },
            ],
            history_params_headers: [
                { text: this.$t("lang.param"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.value"), sortable: false, width: "5%" },
            ],
            enableAddModal: true,
            enableEditModal: true,
            customers: null,
            api_key: {},
            filter: {
                search: "",
                status: "1",
                company_id: "",
            },
            api_key_dialog: false,
            dbGetApiKeys: _.debounce(this.getApiKeys, 1500, { maxWait: 1500, leading: true, trailing: false }),
            api_key_history_dialog: false,
            api_key_history_params_dialog: false,
            api_key_history_params: {},
            reveal: false,
            ip_restriction_list: [],
            confirmReKey: false,
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchApiKeys", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.api_keys) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchApiKeys({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.api_keys) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.api_keys.api_keys_filter,
            page: (state) => state.api_keys.page,
            api_key_history_page: (state) => state.api_keys.api_key_history_page,
            rules_api_keys: (state) => state.api_keys.rules_api_keys,
            api_key_status_options: (state) => state.settings.api_key_status_options,
            api_keys: (state) => state.api_keys.api_keys,
            api_key_history: (state) => state.api_keys.api_key_history,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        apiKeyHistoryParams() {
            return {
                ...this.axiosParams,
                api_keys_id: this.api_key.api_keys_id,
            };
        },
        displayedKey() {
            return this.reveal ? this.api_key.api_key : "•".repeat(this.api_key.api_key.length);
        },
    },
    methods: {
        ...mapActions(["fetchApiKeys", "saveApiKey", "deleteApiKey", "fetchApiKeyHistory", "fetchApiKeyHistoryParams", "reKeyApiKey"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openApiKeyForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_api_key) item ? this.$refs.form_api_key.resetValidation() : this.$refs.form_api_key.reset();

                    this.$nextTick(() => {
                        this.api_key = item != null ? this.assignObj2(item, this.rules_api_keys) : {};
                        this.ip_restriction_list = item != null && this.$isSet(item.ip_addresses) ? item.ip_addresses.split(",") : [];
                        this.reveal = false;
                        this.api_key_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "api_key", params: { id: item.api_keys_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_api_key) item ? this.$refs.form_api_key.resetValidation() : this.$refs.form_api_key.reset();
                    this.api_key = this.assignObj2({}, this.rules_api_keys);
                    this.reveal = false;
                    this.ip_restriction_list = [];
                    this.api_key_dialog = true;
                } else {
                    this.$router.push({ name: "api_key" });
                }
            }
        },
        saveApiKeys() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_api_key")) {
                    this.api_key.ip_addresses = this.ip_restriction_list.length > 0 ? this.ip_restriction_list.join(",") : "";
                    let body = this.prepForm(this.api_key, this.rules_api_keys);

                    this.saveApiKey({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getApiKeys();
                                this.closeApiKeyDialog();
                            } else {
                                this.$router.push({ name: "api_key", params: { id: data.api_keys_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteApiKeys(id = null) {
            this.deleteApiKey({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getApiKeys();
                    this.closeApiKeyDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeApiKeyDialog() {
            this.api_key_dialog = false;
            this.$refs.delete_api_keys.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        closeApiKeyHistoryDialog() {
            this.api_key_history_dialog = false;
        },
        closeApiKeyHistoryParamsDialog() {
            this.api_key_history_params_dialog = false;
        },
        getApiKeys(pg_refresh = false) {
            this.startLoader();

            this.fetchApiKeys({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.api_key_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        openApiKeysHistory(item) {
            this.api_key_history_dialog = true;
            this.fetchApiKeyHistory({ body: { api_keys_id: item.api_keys_id } });
        },
        openApiKeysHistoryParams(id) {
            this.api_key_history_params_dialog = true;
            this.fetchApiKeyHistoryParams({ id: id }).then((data) => {
                if (typeof data !== "undefined") {
                    this.api_key_history_params = phpUnserialize(data.api_rest_logs.params);
                }
            });
        },
        reKeyCurrentApiKey(id) {
            this.reKeyApiKey({ id: id, body: { app_name: this.api_key.app_name } }).then((data) => {
                if (typeof data !== "undefined") {
                    this.api_key = data.api_keys;
                    this.reveal = false;
                    this.confirmReKey = false;
                }
            });
        },
    },
};
</script>
